import React from "react";
import { FiArrowUpRight } from "react-icons/fi";
import useFetch from "../../../../Hooks/useFetch";
import apis from "../../../../Utils/apis";

function BookingsCount() {
	const { response } = useFetch(apis.getBookingCount, null, {
		count: {
			flights: 0,
			stays: 0,
		},
	});

	const { flights, stays } = response.count;

	return (
		<>
			<div className="col-span-2 rounded-2xl my-6">
				<h3>At a Glance</h3>
				<div className="mt-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 text-dark">
					<div className="bg-whitish border rounded-xl p-4 flex flex-col justify-between">
						<h1 className="text-4xl flex-center-between">
							{flights}
							<div className="w-8 h-8 rounded-full bg-surface flex-center text-lg">
								<FiArrowUpRight />
							</div>
						</h1>
						<div className="text-sm mt-2">Flight Bookings</div>
					</div>
					<div className="bg-whitish border rounded-xl p-4 flex flex-col justify-between">
						<h1 className="text-4xl flex-center-between">
							{stays}
							<div className="w-8 h-8 rounded-full bg-surface flex-center text-lg">
								<FiArrowUpRight />
							</div>
						</h1>
						<div className="text-sm mt-2">Stay Bookings</div>
					</div>
				</div>
			</div>
		</>
	);
}

export default BookingsCount;
